import React from 'react'
import {routes} from "./App";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null};
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {error: error.toString()};
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // const { workspace } = this.props;
        // const lastErrorTime = localStorage.getItem('lastErrorTime');
        // const currentTime = Date.now();
        //
        // // Send errors only once per 5 minutes
        // if (!lastErrorTime || (currentTime - lastErrorTime) > FIVE_MINUTE) {
        //     localStorage.setItem('lastErrorTime', currentTime.toString());
        //
        //     // Check if Settings.sendErrors is enabled
        //     if (Settings.sendErrors) {
        //         GeneralRequester.sendWebLogs(workspace, this.state.error, errorInfo)
        //             .then(() => console.log('Error log sent successfully'))
        //             .catch((err) => console.error('Failed to send error log', err));
        //     }
        // } else {
        //     console.log('Error log not sent (within one hour interval)');
        // }
    }

    render() {
        if (this.state.error && !window.location.href.includes('localhost') && !window.location.href.includes('404')) {
            // You can render any custom fallback UI
            window.location.href = routes.NOT_FOUND;
            return null;
        }

        return this.props.children;
    }
}